export enum LifestyleGenerationType {
  LifestyleByPrompt = 'lifestyle_by_prompt',
  LifestyleByReference = 'lifestyle_by_reference',
  Silo = 'silo',
  CloseUp = 'close_up',
  WhiteBackground = 'white_background',
  ConfigVariations = 'config_variations',
  Infographic = 'infographic',
  EditGeneratedImage = 'edit_generated_image',
  // Composer flow: generates a lifestyle from a finished composite-render
  // image url (subject_image_url) instead of a viewer screenshot.
  Composer = 'composer'
}

export enum LifestyleGenerationMode {
  Lifestyle = 'lifestyle',
  Silo = 'silo',
  CloseUp = 'close_up',
  Edit = 'edit',
  // Product-only mode: sends model_id + incoming_payload (scene metadata)
  // instead of a screenshot subject_image_url. Resolves to lifestyle_by_reference
  // when a reference image is attached, otherwise lifestyle_by_prompt.
  ProductLifestyle = 'product_lifestyle'
}

export enum LifestyleGenerationStatus {
  Pending = 'pending',
  Processing = 'processing',
  Success = 'success',
  Failed = 'failed',
  PreparingSource = 'preparing_source'
}

export interface LifestyleGenerationResult {
  id: string;
  image_result: string | null;
  image_result_preview: string | null;
  resolved_aspect_ratio: string;
  resolved_image_size: string;
  metadata: Record<string, unknown> | null;
  created_at: string;
}

export interface CreateLifestyleGenerationInput {
  generation_type: LifestyleGenerationType;
  // Screenshot-based flows pass subject_image_url; product flows
  // (lifestyle_by_prompt / lifestyle_by_reference for a product model) pass
  // model_id + incoming_payload instead.
  subject_image_url?: string;
  model_id?: string | null;
  user_id?: string | null;
  incoming_payload?: Record<string, unknown> | null;
  prompt?: string | null;
  // The composer flow sends an array of reference image urls; the other
  // flows send a single url.
  lifestyle_image_url?: string | string[] | null;
  silo_background_hex?: string | null;
  config_payload?: Record<string, unknown> | null;
  infographic_payload?: Record<string, unknown> | null;
  extra_payload?: Record<string, unknown> | null;
  // Legacy pixel size kept for backward compatibility; the backend resolves
  // the output resolution from aspect_ratio + image_size.
  requested_width?: number | null;
  requested_height?: number | null;
  aspect_ratio?: string | null;
  image_size?: string | null;
  provider?: string | null;
  provider_model?: string | null;
  preferred_provider?: string | null;
  preferred_model?: string | null;
  size_x?: number | null;
  size_y?: number | null;
  size_z?: number | null;
}

export interface CreateLifestyleGenerationResponse {
  id: string;
  generation_type: LifestyleGenerationType;
  subject_image_url: string;
  prompt: string | null;
  lifestyle_image_url: string | null;
}

export interface FetchLifestyleGenerationResponse {
  id: string;
  generation_type: LifestyleGenerationType;
  status: LifestyleGenerationStatus;
  subject_image_url: string;
  prompt: string | null;
  lifestyle_image_url: string | null;
  provider: string;
  provider_model: string;
  error_message: string | null;
  results: LifestyleGenerationResult[];
  created_at: string;
  updated_at: string;
}
